import React, { useState, useEffect,useCallback } from "react";
import Modal from "react-modal";
import axios from "axios";
import FeedbackSystem from "../../../utils/feedbacksystem";
import ViewMakeCounterOffer from "./ViewMakeCounterOffer";
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import BigShowCompleteCard from "../../Card/BigShowCompleteCard";
import { toast } from 'react-toastify';
import { useNavigate,useSearchParams } from "react-router-dom";
import Select from "react-select";
import PriceBreakdown from "../PriceBreakdown";
import TransactionCommentFeed from "./TransactionCommentFeed";
import ContactNowButton from "../../UsefulComponent/ContactNowButton";
const ModalViewSelectedSales = ({ offer, Status, userId,liveCsrfToken,fetchSoldOrOffer, show,
  onClose }) => {
  
    const navigate = useNavigate();
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language

 const [searchParams, setSearchParams] = useSearchParams();
  const t = (key) => {
    if (
      !translations.ModalViewSelectedSales[key] ||
      !translations.ModalViewSelectedSales[key][currentLang]
    ) {
      console.error(`Missing translation for key: ${key} in language: ${currentLang}`);
      return key; // Fallback to the key itself
    }
    return translations.ModalViewSelectedSales[key][currentLang];
  };
  
  const [sellerId, setSellerId] = useState(0);
  const [buyerId, setBuyerId] = useState(0);
  const [IsACounterOffer, setIsACounterOffer] = useState(false);
  const [currentSaleId, setCurrentSaleId] = useState(0);
  const [answerComments, setAnswerComments] = useState("");
  const [selectedCarrier, setSelectedCarrier] = useState("canadaPost"); // Set default carrier to Canada Post
  const [selectedTracking, setSelectedTracking] = useState("untracked"); // Set default tracking to Untracked
  const [selectedImage, setSelectedImage] = useState(null);
  const [prefillMessage,setPrefillMessage]= useState("")
  const [isAnOffer, setIsAnOffer] = useState(false);
  const [price, setPrice] = useState(offer?.[0]?.Price || 0);
  const [total, setTotal] = useState(0);

  const [isBestOfferVisible, setIsBestOfferVisible] = useState(false);
  const [bestOfferAmount, setBestOfferAmount] = useState("");
  const [bestOfferSaved, setBestOfferSaved] = useState(false);
  const  [otherUserContact,setOtherUserContact] = useState([])
  const [userCardsIds,setUserCardsIds] = useState([])



  const stylingSelect = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222",
      borderColor: "#444", // subtle
      boxShadow: "0 0 4px rgba(0, 102, 255, 0.2)", // slight glow
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1a1a1a", // Set the background color of the dropdown menu to black
      color: "white", // Set the text color of the dropdown menu to white
    }),
    option: (provided, state) => ({
      ...provided,
      color: "white", // Set the text color for selected and non-selected options
      backgroundColor: state.isSelected ? "#0066FFED" : null, // Set the background color for selected options
      "&:hover": {
        backgroundColor: "#0066FFED", // Set the background color for hover effect
        color: "white", // Set the text color for hover effect
      },
    }),
  };

  const fetchUserContactInfo = async (otherUserId) => {
    console.log('confirmation,otherUserId',otherUserId)
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/getLightUser/UserId/${otherUserId}`, {
        method: 'GET',
        credentials: 'include', // Ensures the session cookie is sent with the request
      });
  
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
  
      const json = await res.json();
      
      console.log('json', json);
      
      setOtherUserContact({
        otherUserId: json.UserId,
        ShowName: json.ShowName,
        FacebookProfile: json.FacebookProfile,
        InstagramProfile: json.InstagramProfile,
      });
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };







  useEffect(() => {
    
    if (show && buyerId!==0) {

      const otherUserId = userId === buyerId ? sellerId : buyerId; // Get the opposite user
      console.log('confirmation 74',otherUserId)
      console.log('confirmation 75',buyerId," ",sellerId)
      console.log('confirmation 76',offer[0].SellerId)
      console.log('confirmation 76',Status)
      
      fetchUserContactInfo(otherUserId);
    }
  }, [show,buyerId]);


  const generatePrefillMessage = () => {
    let intro = "";
  
    if (Status === "Waiting" || Status === "Counter") {
      intro = t("I'm interested in your card(s):");
    } else if (Status === "PayNow" && userId === buyerId) {
      intro = t("I have completed the payment for our deal. Here are the details:");
    } else if (Status === "ShipNow" && userId === sellerId) {
      intro = t("I'm preparing the shipment. Here are the details of the deal:");
    } else if (Status === "ComingYourWay" && userId === buyerId) {
      intro = t("I'm following up on the shipment. Could you provide an update?");
    } else {
      intro = "";  // Fallback
    }
  
    if (intro === "") return "";  // Avoid sending a blank message
  
    const lines = offer.map((card) => {
      const player = card.Name || "N/A";
      const number = card.NumberBehind ? ` #${card.NumberBehind}` : "";
      const set = card.SetName || "N/A";
      const variation = `${card.cardName || "N/A"} - ${card.variationName || "N/A"}`;
      const price = (card.SalePrice ?? card.Price) >= 0 ? `${t("Price")}: $${card.SalePrice ?? card.Price}` : "";
      const tv = card.EstimateValue >= 0 ? `${t("TV")}: $${card.EstimateValue}` : "";
  
      return `- ${player}${number}\n  ${t("Set")}: ${set}\n  ${t("Variation")}: ${variation}${price ? `\n  ${price}` : ""}${tv ? `\n  ${tv}` : ""}`;
    });
  
    return `${intro}\n\n${lines.join("\n\n")}${(Status === "Waiting" || Status === "Counter" || Status === "PayNow" || Status === "ShipNow") ? `\n\n${t("Total")}: $${total}` : ""}`;
  };
  

  useEffect(() => {
console.log('otherUserContact')
  }, [otherUserContact]);
  
  function resetBestOffer() {
    setIsBestOfferVisible(false);
    setBestOfferAmount("");
    setBestOfferSaved(false);
    setIsAnOffer(false);
    setPrice(offer[0].Price);
  }

  function extractUserCardIds(offer) {
    return offer.map(item => item.usercardsId);
  }


  // transactionId,cards, IsAnOffer,Price,SellerId,BuyerId,Date,
  const prepareIds = () => {
    const sellerId = offer[0].SellerId ? offer[0].SellerId : 999;
    const buyerId = offer[0].BuyerId ? offer[0].BuyerId : 999;
    const transactionId = offer[0].TransactionId ? offer[0].TransactionId : 0;
    setCurrentSaleId(transactionId);
    setSellerId(sellerId);
    setBuyerId(buyerId);
    console.log('id for usercards',offer)
    const tempoUserCardsIds = extractUserCardIds(offer);
    setUserCardsIds(tempoUserCardsIds)
  };
  useEffect(() => {
    prepareIds();
  }, [offer]);
 const updateParams = useCallback((patch, replace = true) => {
    const sp = new URLSearchParams(searchParams);
    Object.entries(patch).forEach(([k, v]) => {
      if (v == null || v === "") sp.delete(k);
      else sp.set(k, String(v));
    });
    setSearchParams(sp, { replace });
  }, [searchParams, setSearchParams]);
  const closeModal = () => {
    resetBestOffer()
   onClose()
   updateParams({ transactionId: null })
   console.log('onclocse fiat')
  };

  const handleCommentChange = async (event) => {
    await setAnswerComments(event.target.value);
  };
  
  function markedAsNotPaid(){
    console.log('')
  }
  function markedAsNotShipped(){
    console.log('')
  }

  async function markedAsNotPaid(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/markedAsNotPaid`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        console.log("Successfully marked as not paid");
        toast.success(t("Marked as not paid successfully"));
      } else {
        console.error("Failed to mark as not paid:", response.data.error);
        toast.error(t("Failed to mark as not paid") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error marking as not paid:", error.message || error);
      toast.error(t("Error marking as not paid") + ": " + error.message);
    }
  }
  
  async function markedAsNotShipped(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/markedAsNotShipped`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }
      );
  
      if (response.data.success) {
        console.log("Successfully marked as not shipped");
        toast.success(t("Marked as not shipped successfully"));
      } else {
        console.error("Failed to mark as not shipped:", response.data.error);
        toast.error(t("Failed to mark as not shipped") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error marking as not shipped:", error.message || error);
      toast.error(t("Error marking as not shipped") + ": " + error.message);
    }
  }


  async function markedAsPaid(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/markedAsPaid`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Successfully marked as paid
        console.log("Successfully marked as paid");
        toast.success(t("Marked as paid successfully"));
      } else {
        // Failed to mark as paid
        console.error("Failed to mark as paid:", response.data.error);
        toast.error(t("Failed to mark as paid") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error marking as paid:", error.message || error);
      toast.error(t("Error marking as paid") + ": " + error.message);
    }
  }
  
  async function markedAsShipped(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/markedAsShipped`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          Carrier: selectedCarrier,
          TypeTracking: selectedTracking,
          ConfirmationPicture: selectedImage,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Successfully marked as shipped
        console.log("Successfully marked as shipped");
        toast.success(t("Marked as shipped successfully"));
      } else {
        // Failed to mark as shipped
        console.error("Failed to mark as shipped:", response.data.error);
        toast.error(t("Failed to mark as shipped") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error marking as shipped:", error.message || error);
      toast.error(t("Error marking as shipped") + ": " + error.message);
    }
  }
  
  async function markedAsReceived(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/markedAsReceived`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Successfully marked as received
        console.log("Successfully marked as received");
        toast.success(t("Marked as received successfully"));
        resetCardDataOnReceived(userCardsIds,sellerId,buyerId,price,liveCsrfToken)
      } else {
        // Failed to mark as received
        console.error("Failed to mark as received:", response.data.error);
        toast.error(t("Failed to mark as received") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error marking as received:", error.message || error);
      toast.error(t("Error marking as received") + ": " + error.message);
    }
  }
  
  
async function resetCardDataOnReceived(userCardsIds,previousOwnerId, newOwnerId,price, liveCsrfToken) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE}/api/marketplace/resetCardDataOnReceived`,
      {
        userCardsIds,
        previousOwnerId,
        newOwnerId,
        price,
        liveCsrfToken,
      },
      { withCredentials: true }
    );

    if (response.data.success) {
      toast.success(t('Card data reset and transfered!'));
    } else {
      toast.error(`Failed: ${response.data.message}`);
    }
  } catch (error) {
    console.error('Error:', error);
    toast.error('Error resetting card data.');
  }
}

  async function acceptTheSaleOffer(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/acceptOffer`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          liveCsrfToken: liveCsrfToken,  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Trade offer was accepted successfully
        console.log("Offer Accepted");
        toast.success(t("Offer accepted successfully"));
        
      } else {
        // Trade offer acceptance failed
        console.error("Failed to accept trade offer:", response.data.error);
        toast.error(t("Failed to accept trade offer") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error accepting trade offer:", error.message || error);
      toast.error(t("Error accepting trade offer") + ": " + error.message);
    }
  }

  async function rejectTheOffer(transactionId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/rejectOffer`,
        {
          transactionId: transactionId,
          SellerId: sellerId,
          BuyerId: buyerId,
          AnswerComments: answerComments,
          liveCsrfToken: liveCsrfToken,  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Trade offer was rejected successfully
        console.log("Offer Rejected");
        toast.success(t("Offer rejected successfully"));
      } else {
        // Trade offer rejection failed
        console.error("Failed to reject offer:", response.data.error);
        toast.error(t("Failed to reject offer") + ": " + response.data.error);
      }
    } catch (error) {
      console.error("Error rejecting trade offer:", error);
      toast.error(t("Error rejecting trade offer") + ": " + error.message);
    }
  }

  const cancelXIcon = () => {
    return (
      <span onClick={() => resetBestOffer()} style={{marginBottom:'2vh'}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="#000"
          version="1.1"
          viewBox="0 0 128 128"
          xmlSpace="preserve"
        >
          <g>
            <path
              fill="#0066FFED"
              d="M64 0C28.656 0 0 28.656 0 64s28.656 64 64 64 64-28.656 64-64S99.344 0 64 0zm0 120C33.125 120 8 94.875 8 64S33.125 8 64 8s56 25.125 56 56-25.125 56-56 56z"
            ></path>
            <path
              fill="#F44336"
              d="M75.313 64l16.969-16.969c3.125-3.125 3.125-8.195 0-11.313-3.117-3.125-8.188-3.125-11.313 0L64 52.688 47.031 35.719c-3.125-3.125-8.195-3.125-11.313 0-3.125 3.117-3.125 8.188 0 11.313L52.688 64 35.719 80.969c-3.125 3.125-3.125 8.195 0 11.313 3.117 3.125 8.188 3.125 11.313 0L64 75.313l16.969 16.969c3.125 3.125 8.195 3.125 11.313 0 3.125-3.117 3.125-8.188 0-11.313L75.313 64z"
            ></path>
          </g>
        </svg>
      </span>
    );
  };

  const disketteSaveIcon = (saved) => {
    const DisketteSaveBlue = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        fill="#0066FFED"
        stroke="#0066FFED"
        version="1.1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <g>
          <path d="M506.513 98.709L413.291 5.486A18.73 18.73 0 00400.047 0H385.77a6.245 6.245 0 00-6.244 6.244v151.114c0 10.345-8.387 18.732-18.732 18.732H151.196c-10.345 0-18.732-8.387-18.732-18.732V6.244A6.245 6.245 0 00126.22 0H18.732C8.387 0 0 8.387 0 18.732v474.537C0 503.613 8.387 512 18.732 512h474.537c10.345 0 18.732-8.387 18.732-18.732V111.954a18.732 18.732 0 00-5.488-13.245zM400.554 410.226c0 10.345-8.387 18.732-18.732 18.732H130.178c-10.345 0-18.732-8.387-18.732-18.732V263.094c0-10.345 8.387-18.732 18.732-18.732h251.644c10.345 0 18.732 8.387 18.732 18.732v147.132z"></path>
          <path d="M176.172 126.138h159.647a6.244 6.244 0 006.244-6.244V6.244A6.245 6.245 0 00335.819 0H176.172a6.245 6.245 0 00-6.244 6.244v113.65a6.245 6.245 0 006.244 6.244zm99.174-79.868c0-10.345 8.387-18.732 18.732-18.732s18.732 8.387 18.732 18.732v33.598c0 10.345-8.387 18.732-18.732 18.732s-18.732-8.387-18.732-18.732V46.27zM318.413 317.93H193.586c-10.345 0-18.732 8.387-18.732 18.732s8.387 18.732 18.732 18.732h124.828c10.345 0 18.73-8.387 18.73-18.732s-8.386-18.732-18.731-18.732z"></path>
        </g>
      </svg>
    );
    return saved ? (
      <button onClick={submitBestOffer}>
        <DisketteSaveBlue />
      </button>
    ) : (
      null
    );
  };
  useEffect(() => {
    const newPrice = parseFloat(offer?.[0]?.Price || 0);
    const newShipping = parseFloat(offer?.[0]?.Shipping || 0);
  
    setPrice(newPrice); // ✅ reset price based on new offer
    setBestOfferAmount(""); // reset any old input
    setBestOfferSaved(false);
    setIsBestOfferVisible(false);
  
    if (!isNaN(newPrice) && !isNaN(newShipping)) {
      setTotal(newPrice + newShipping);
    } else {
      setTotal(0);
    }
  }, [offer]);

useEffect(() => {
    const thisPrice = parseFloat(price);
    const shipping = parseFloat(offer[0].Shipping);
    const bestoffer = parseFloat(bestOfferAmount);

    if (bestoffer === thisPrice) setBestOfferSaved(true);
    else setBestOfferSaved(false);

    if (isBestOfferVisible) {
      if (!isNaN(bestoffer) && !isNaN(shipping)) {
        setTotal(bestoffer + shipping);
      } else {
        setTotal(0); // Set total to 0 if parsing fails
      }
    } else {
      // Check if the parsed values are valid numbers
      if (!isNaN(thisPrice) && !isNaN(shipping)) {
        setTotal(thisPrice + shipping);
      } else {
        setTotal(0); // Set total to 0 if parsing fails
      }
    }
  }, [price, bestOfferAmount, isBestOfferVisible]);
  const showBestOfferInput = () => {
    setIsBestOfferVisible(!isBestOfferVisible);
      // Delay focus slightly to ensure input is mounted
  // setTimeout(() => {
  //   document.getElementById("bestOfferInput")?.focus();
  // }, 100);
  };

  const handleBestOfferChange = (event) => {
    const value = event.target.value;
    if (
      value === "" ||
      (!isNaN(value) && value.trim() !== "" && !/^0\d/.test(value))
    )
      setBestOfferAmount(value);
  };

  const submitBestOffer = async () => {
    // Perform any actions with the best offer amount here
    const thisPrice = parseFloat(bestOfferAmount);
    const shipping = parseFloat(offer[0].Shipping);

    // Check if the parsed values are valid numbers
    if (!isNaN(thisPrice) && !isNaN(shipping)) {
      setTotal(thisPrice + shipping);
    } else {
      setTotal(0); // Set total to 0 if parsing fails
    }

    setPrice(bestOfferAmount);
    setIsAnOffer(true);
    // Reset the state or close the input field if needed
    //setIsBestOfferVisible(false);
    //setBestOfferAmount('');
  };


  //BuyerId={buyerId}
  //           SellerId={sellerId}
  //           TransactionId={currentSaleId}
  //           onClose={handleCloseCounterOffer}
  //           AnswerComments={answerComments}
  //           Offer={offer}
  //           userId={userId}
  //           liveCsrfToken={liveCsrfToken}
  //           t={t}
const handleSubmitOffer = () => {
  console.log('offer123',offer)
  const userCardsId = buildCardDataArray(offer);
  const cleanPrice = Number.parseFloat(price); // ensure number
  console.log('buyerId, sellerId, userCardsId, cleanPrice, answerComments, offer[0].Shipping',buyerId, sellerId, userCardsId, cleanPrice, answerComments, offer[0].Shipping)
  sendCounterOffer(sellerId,buyerId , userCardsId, cleanPrice, answerComments, offer[0].Shipping);
  fetchSoldOrOffer();
  closeModal();
};

  function sendCounterOffer(
    SellerId,
    BuyerId,
    userCardsId,
    Price,
    comment,
    shipping
  ) {
    console.log(
      "SellerId, BuyerId,rawCards, Price,comment,shipping",
      SellerId,
      BuyerId,
      userCardsId,
      Price,
      comment,
      shipping
    );
   
    if (userCardsId.length > 0) {
      submitCounterOffer(
        SellerId,
        BuyerId,
        userCardsId,
        Price,
        comment,
        shipping
      );
      console.log("Offer Send");
    }
     else  console.log(t("Counter offer is not completed"));
 
  }

  function buildCardDataArray(cards) {
    return cards.map((card) => card.usercardsId);
  }

  async function submitCounterOffer(SellerId, BuyerId, cards, Price, comment, shipping) {
    try {
      // Perform client-side validation
      if (
        SellerId == null ||
        BuyerId == null ||
        cards == null || cards.length === 0 ||
        Price == null ||
        shipping == null
      ) {
        throw new Error("All required fields must be filled.");
      }
  
      // Convert Price to a float (double in your database)
      const priceAsDouble = parseFloat(Price);
      if (isNaN(priceAsDouble) || priceAsDouble <= 0) {
        throw new Error(t("Price must be a positive number"));
      }
  
   

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/submitCounterOffer`,
        {
          SellerId: SellerId,
          BuyerId: BuyerId,
          UserCardIds: cards,
          Price: priceAsDouble,  // Send Price as a floating-point number
          Shipping: shipping,
          Comments: comment,
          ParentOfferId: offer[0].TransactionId,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      // Handle the response from the server
      if (response.data.success) {
        toast.success(t("Counter offer submitted successfully!"));
        setCounteredTheOffer(SellerId, BuyerId, comment);
        //resetAll();
      } else {
        toast.error(`${t("Failed to submit counter offer")}: ${response.data.error}`);
      }
    } catch (error) {
      toast.error(`${t("Failed to submit counter offer")}: ${error.message}`);
    }
  }


  async function setCounteredTheOffer(SellerId, BuyerId, comment) {
    try {
      console.log("SellerId, BuyerId", SellerId, BuyerId);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/marketplace/counteredOffer`,
        {
          transactionId: offer[0].TransactionId,
          SellerId: SellerId,
          BuyerId: BuyerId,
          AnswerComments: comment,
          liveCsrfToken: liveCsrfToken  // Include CSRF token
        },
        { withCredentials: true }  // Ensure credentials (cookies) are included
      );
  
      if (response.data.success) {
        // Offer was successfully set to countered
        console.log("Offer set to countered");
      } else {
        console.error("Failed to set offer to countered:", response.data.error);
      }
    } catch (error) {
      console.error("Error countering offer:", error.message || error);
    }
  }


  const handleMarkedAsPaid = () => {
    // Add logic for accepting the trade
    console.log("Mark as paid");
    markedAsPaid(currentSaleId);
    fetchSoldOrOffer()
    closeModal();
  };
  const handleMarkedAsShipped = () => {
    // Add logic for accepting the trade
    console.log("Mark as Shipped");
    markedAsShipped(currentSaleId);
    fetchSoldOrOffer()
    closeModal();
  };
  const handleMarkedAsNotPaid = () => {
    // Add logic for accepting the trade
    console.log("Mark as Not paid");
    markedAsNotPaid(currentSaleId);
    fetchSoldOrOffer()
    closeModal();
  };
  const handleMarkedAsNotShipped = () => {
    // Add logic for accepting the trade
    console.log("Mark as Not Shipped");
    markedAsNotShipped(currentSaleId);
    fetchSoldOrOffer()
    closeModal();
  };

  const handleGetDefaultAdress = () => {
    goGetAdress();
  };

  const combineAdress = (returns) => {
    if (returns) {
      const { FirstName, LastName, Address, City, State, Country, ZipCode } =
        returns;

      const formattedAddress = `${FirstName} ${LastName}\n${Address}\n${City} ${ZipCode}\n${State}, ${Country}`;

      console.log("Formatted Address:", formattedAddress);
      setAnswerComments(formattedAddress);
      // You can use the formattedAddress as needed, for example, copy it to the clipboard
      // or display it for the seller to copy and paste
    }
  };
  async function goGetAdress() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/users/getUserShipping`,
        {
          params: {
            userId: userId,
          },  
        withCredentials: true, // ✅ sends cookies/session
      }
        
      );

      if (response.data.success) {
        // Shipping information retrieved successfully
        console.log("Shipping information:", response.data.data);
        combineAdress(response.data.data);
        // Perform additional actions if needed
      } else {
        // Failed to retrieve shipping information
        console.error(
          "Failed to retrieve shipping information:",
          response.data.error
        );
        // Handle error scenarios if necessary
      }
    } catch (error) {
      console.error("Error retrieving shipping information", error);
      // Handle error scenarios if necessary
    }
  }

  const handleMarkedAsReceived = () => {
    // Add logic for accepting the trade
    console.log("Mark as Received");
    markedAsReceived(currentSaleId);
    closeModal();
  };
  const handleAccept = () => {
    // Add logic for accepting the trade
    console.log("Accepted");
    //const transactionId = offer[0].TransactionId?offer[0].TransactionId:99;
    acceptTheSaleOffer(currentSaleId);
    fetchSoldOrOffer()
    closeModal();
  };

  const handleReject = () => {
    // Add logic for rejecting the trade
    console.log("Rejected");
    // const transactionId = offer[0].TransactionId?offer[0].TransactionId:98;
    rejectTheOffer(currentSaleId);
    fetchSoldOrOffer()
    closeModal();
  };

  const handleCounterOffer = () => {
    // Add logic for proposing a counter offer
    console.log("Counter Offer");
   // setIsACounterOffer(true);
   showBestOfferInput()
    //closeModal();
  };

  const handleCloseCounterOffer = () => {
    console.log("Counter Offer /closed ");
    setIsACounterOffer(false);
    closeModal();
  };

  const handleCarrierChange = (event) => {
    setSelectedCarrier(event.target.value);
  };

  const handleTrackingChange = (event) => {
    setSelectedTracking(event.target.value);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      // Handle invalid file type
      alert("Please select a valid image file.");
    }
  };

 

  function generatePriceTable(pricing,shipping) {
    return (
      <div className="price-table"
        style={{
          color: "white",
          border: "1px solid #ccc",
          padding: "20px",
          borderRadius: "5px",
          backgroundColor: "black",
          width:'auto'
        }}
      >
        <table>
          <tbody>
            {/* Price Row */}
            <tr className="sale-price-container">
              <td>{t("Price")}</td>
              <td>
              {isBestOfferVisible ? (
    <div className="offer-container">
      
      <input
  type="text"
  id="bestOfferInput"
  value={bestOfferAmount}
  onChange={handleBestOfferChange}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      submitBestOffer();
    }
  }}
  className="offer-input noMargin"
  style={{marginTop:'0'}}
/>
       {cancelXIcon()}
      {disketteSaveIcon(!bestOfferSaved)}
     
    </div>
  ) : (
    pricing + "$"
  )}


              </td>
            </tr>
  
            {/* Shipping Row */}
            <tr className="sale-shipping-container">
              <td>{t("Shipping")}</td>
              <td colSpan="3" className="sale-shipping">
                {shipping}$
              </td>
            </tr>
  
            {/* Total Row */}
            <tr className="sale-total-row">
              <td>{t("Total")}</td>
              <td colSpan="3">{total}$</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
  

const handleOfferSubmit = (newPrice) => {
  const ship = Number(offer?.[0]?.Shipping ?? 0);
  setPrice(newPrice);
  setIsAnOffer(true);
  setTotal(Number(newPrice) + ship);
  
};

const handleOfferCancel = () => {
  const orig = Number(offer?.[0]?.Price ?? 0);
  const ship = Number(offer?.[0]?.Shipping ?? 0);
  setPrice(orig);
  setIsAnOffer(false);
  setTotal(orig + ship);
    
};


return (
  <div>
    {/* <button onClick={openModal} className="btn-baseBlue full-right-side">
      {t("View")}
    </button> */}
    
    {IsACounterOffer ? (
      <ViewMakeCounterOffer
        BuyerId={buyerId}
        SellerId={sellerId}
        TransactionId={currentSaleId}
        onClose={handleCloseCounterOffer}
        AnswerComments={answerComments}
        Offer={offer}
        userId={userId}
        liveCsrfToken={liveCsrfToken}
        t={t}
      />
    ) : (
       <Modal
      isOpen={show}
      onRequestClose={closeModal}
      className="modal-container NoLimit"
      overlayClassName="modal-overlay"
    >
        <div className="modal-offer-container">
          <h2 style={{marginBottom:'0px'}}>{offer[0].Status}</h2>
          {/* Offer Details Section */}
          <div className="offer-section-selected">
            
            {/* Left: Giving Section */}
            <div className="offer-column giving-section">
              {/* <h2 className="section-title-selected">{t("Giving")} ({offer.length})</h2>  */}
              <div className="profile-info" style={{cursor:'pointer'}} onClick={() =>navigate(i18n.language === 'fr' ? `/fr/ViewUserProfil/${offer[0].SellerName}`:`/ViewUserProfil/${offer[0].SellerName}`)}>
              
              <div className="user-info">
              <span className="role seller-role">{t('Seller')}</span>
              <img src={offer[0].SellerProfileImage || '/default-avatar.png'} alt="Seller" className="profile-img" />
                <p className="username">{offer[0].SellerName}</p>
                <p className="rating">({offer[0].SellerTransactions||0}){(offer[0].SellerRating * 20).toFixed(0)}%</p>
              </div>
            </div>
            
              <div className="card-list">
                {offer.map((card, index) => (
                  <div key={index} className="card-container">
                    <BigShowCompleteCard formData={card} isForCreate={false} useMinHeight={false} showPrice={true}/>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Receiving Section */}
            <div className="offer-column receiving-section">
              {/* <h2 className="section-title-selected">{t("Receiving")} ({offer.length})</h2>
               */}
              <div className="profile-info" style={{cursor:'pointer'}} onClick={() =>navigate(i18n.language === 'fr' ? `/fr/ViewUserProfil/${offer[0].BuyerName}`:`/ViewUserProfil/${offer[0].BuyerName}`)}>
                
             
              <div className="user-info">
              <span className="role buyer-role">{t('Buyer')}</span><br />
              <img src={offer[0].BuyerProfileImage || '/default-avatar.png'} alt="Buyer" className="profile-img" />
                <p className="username">{offer[0].BuyerName}</p>
                <p className="rating">({offer[0].BuyerTransactions||0}){(offer[0].BuyerRating * 20).toFixed(0)}%</p>
              </div>
            </div>
              {/* {generatePriceTable(offer[0].Price, offer[0].Shipping)} */}
<PriceBreakdown
  t={t}
  price={price}                         // use current state, not offer[0].Price
  shipping={offer[0].Shipping}
  total={total}
  onOfferSubmit={handleOfferSubmit}     // <-- wire it
  onOfferCancel={handleOfferCancel}     // <-- wire it
  editable={isBestOfferVisible}
/>
            </div>

          </div>



          <TransactionCommentFeed transaction={offer[0]} t={t} userId={userId} locale={i18n.language}     // optional
  reverse={false}/>





          {/* Comments Section */}
    

          {/* Action Buttons */}
 {/* === Waiting / Counter actions === */}
<div className="action-section">

  {(Status === "Waiting" || Status === "Counter") && ( <>
  {otherUserContact?.FacebookProfile && (
    <div className="contact-section">
      <a href={otherUserContact.FacebookProfile} target="_blank" rel="noopener noreferrer">
        <button className="btn btn-secondary">{t("Contact Seller")} • Facebook</button>
      </a>
    </div>
  )}

  <div className="contact-row">
    <ContactNowButton
      targetUserId={otherUserContact.otherUserId}
      targetShowName={otherUserContact.ShowName}
      t={t}
    />
  </div>

  <div className="comment-section card">
    <label className="field-label">{t("Comment")}</label>
    <textarea
      value={answerComments}
      onChange={handleCommentChange}
      maxLength={254}
      rows={4}
      placeholder={t("Write a comment for the seller")}
      className="textarea"
    />
  </div>

  <div className="button-group">
    {!isBestOfferVisible && (
      <button onClick={handleAccept} className="btn btn-primary">{t("Accept")} ✔️</button>
    )}
    <button onClick={handleReject} className="btn btn-danger">{t("Reject")} ❌</button>
    {!isBestOfferVisible ? (
      <button onClick={handleCounterOffer} className="btn btn-secondary">
        {t("Counter Offer")} 🔁
      </button>
    ) : (
      <button onClick={handleSubmitOffer} className="btn btn-primary">
        {t("Submit counter Offer")}
      </button>
    )}
    
  </div></>)}
</div>



          {Status === "WaitingPayment" && offer[0].SellerId === userId &&(
  <> 
    {otherUserContact?.FacebookProfile && (
      <div className="contact-section">
        <a href={otherUserContact.FacebookProfile} target="_blank" rel="noopener noreferrer">
          <button className="btn btn-secondary">{t("Contact Seller")}</button>
        </a>
      </div>
    )}

    <div className="contact-row">
    <ContactNowButton 
   targetUserId={otherUserContact.otherUserId} 
   targetShowName={otherUserContact.ShowName} 
   prefillMessage={generatePrefillMessage()} 
   t={t}
 />
  </div>


 <button className="btn btn-primary" onClick={handleMarkedAsPaid}>
   {t("Mark as Paid")}
 </button>
 </>
)}

{/* === Pay Now (buyer) === */}
{Status === "PayNow" && offer[0].BuyerId === userId && (
  <div className="payment-section">
    {otherUserContact?.FacebookProfile && (
      <div className="contact-section">
        <a href={otherUserContact.FacebookProfile} target="_blank" rel="noopener noreferrer">
          <button className="btn btn-secondary">{t("Contact Seller")}</button>
        </a>
      </div>
    )}

    <div className="contact-row">
      <ContactNowButton
        targetUserId={otherUserContact.otherUserId}
        targetShowName={otherUserContact.ShowName}
        prefillMessage={generatePrefillMessage()}
        t={t}
      />
    </div>

    <div className="comment-section card">
      <label className="field-label">{t("Comment")}</label>
      <textarea
        value={answerComments}
        onChange={handleCommentChange}
        maxLength={254}
        rows={4}
        className="textarea"
        placeholder={t("Write down your shipping address and/or a comment for the seller before shipping...")}
      />
      <button className="btn btn-ghost small" onClick={handleGetDefaultAdress}>
        {t("DefaultAddress")}
      </button>
    </div>

    <div className="payment-warning card">
      {t("If you are absolutely sure the seller is legitimate and have Proof or Vouch - Then send payment and provide password")}
    </div>

    <button className="btn btn-primary" onClick={handleMarkedAsPaid}>
      {t("Mark as Paid")}
    </button>
  </div>
)}


{Status === "WaitingShipment" && offer[0].BuyerId === userId &&(

  <>
    {otherUserContact?.FacebookProfile && (
      <div className="contact-section">
        <a href={otherUserContact.FacebookProfile} target="_blank" rel="noopener noreferrer">
          <button className="btn btn-secondary">{t("Contact Seller")}</button>
        </a>
      </div>
    )}
      <div className="contact-row">
 <ContactNowButton 
   targetUserId={otherUserContact.otherUserId} 
   targetShowName={otherUserContact.ShowName} 
   prefillMessage={generatePrefillMessage()} 
   t={t}
 />
  </div> 
 <button className="btn btn-primary" onClick={handleMarkedAsNotPaid}>
   {t("Mark as Not Paid")}
 </button>
 </>
)}
          {/* Shipping Section */}
 {/* === Ship Now (seller) === */}
{Status === "ShipNow" && offer[0].SellerId === userId && (
  <div className="ship-now-section">
    <div className="contact-row">
      <ContactNowButton
        targetUserId={otherUserContact.otherUserId}
        targetShowName={otherUserContact.ShowName}
        prefillMessage={generatePrefillMessage()}
        t={t}
      />
    </div>

    <div className="row gap">
      <button className="btn btn-ghost" onClick={handleMarkedAsNotPaid}>
        {t("Mark as Not Paid")}
      </button>
    </div>

    <div className="row gap card">
      <div className="field">
        <label className="field-label">{t("Select Carrier")}</label>
        <select id="carrier" value={selectedCarrier} onChange={handleCarrierChange} className="select">
          <option value="canadaPost">{t("Canada Post")}</option>
          <option value="ups">UPS</option>
          <option value="fedex">FedEx</option>
        </select>
      </div>

      <div className="field">
        <label className="field-label">{t("Select Tracking")}</label>
        <select id="tracking" value={selectedTracking} onChange={handleTrackingChange} className="select">
          <option value="tracked">{t("Tracked")}</option>
          <option value="untracked">{t("Untracked")}</option>
        </select>
      </div>
    </div>

    <div className="file-upload card">
      <label className="field-label">{t("Add proof of shipment (Absolutely Required)")}</label>
      <input type="file" accept="image/*" onChange={handleImageChange} className="file" />
    </div>

    <div className="two-col">
      <div className="comment-section card">
        <label className="field-label">{t("Tracking Information or comment for the buyer")}</label>
        <textarea
          value={answerComments}
          onChange={handleCommentChange}
          maxLength={254}
          placeholder={t("Write to the buyer")}
          className="textarea"
        />
      </div>

      <div className="confirm card">
        <p className="muted">
          {t("If you are absolutely sure the buyer paid and have proof of shipping, then you can continue")}
        </p>
        <button onClick={handleMarkedAsShipped} className="btn btn-primary">
          {t("Mark as Shipped")}
        </button>
      </div>
    </div>
  </div>
)}



          {/* Confirm Received Section */}
          {Status === "Shipped" &&  offer[0].SellerId === userId  && (
            <>

                <div className="contact-row">
            <ContactNowButton 
  targetUserId={otherUserContact.otherUserId} 
  targetShowName={otherUserContact.ShowName} 
  prefillMessage={generatePrefillMessage()} 
  t={t}
/> 
  </div> 

<button className="btn btn-ghost" onClick={handleMarkedAsNotShipped}>
   {t("Mark as Not Shipped")}
 </button>
            </>
          )}


          {Status === "ComingYourWay" && offer[0].BuyerId === userId && (
            <>
            <div className="contact-row">
            <ContactNowButton 
  targetUserId={otherUserContact.otherUserId} 
  targetShowName={otherUserContact.ShowName} 
  prefillMessage={generatePrefillMessage()} 
  t={t}
/></div>
              <FeedbackSystem transactionId={currentSaleId} concernedUserId={sellerId} FromUserId={buyerId} handleMarkedAsReceived={handleMarkedAsReceived}/>
            
            </>
          )}

          {/* Close Button */}
          <button onClick={closeModal} className="btn-close">{t("Close")}</button>
        </div>
      </Modal>
    )}
  </div>
);

};

export default ModalViewSelectedSales;
